export default "__VITE_ASSET__C8FPug78__"